export enum FacetType {
  Iterable = 'ITERABLE',
  Single = 'SINGLE',
  Date = 'DATE',
  CatalogDate = 'CATALOG_DATE',
  Collections = 'COLLECTIONS',
  Locations = 'LOCATIONS',
}
